import React, { useState, useContext, useEffect } from "react";
//import PropsLoader from './PropsLoader';
import MyContext from "../context/MyContext";
import TickerContext from "../context/ticker";
import AuthContext from "../context/userAuth.context";
import PropsLoader from "../editor.component/leftmenu.component/SUBcomponents/Assets/PropsLoader";
import Swal from "sweetalert2";
import axios from "axios";
import UpdateTags from "./UpdateTags";

function AssetPropSearch(props) {
  const [ShowItems, setShowItems] = useState(false);
  const [open, setOpen] = useState(false);
  const [itemId, setItemId] = useState(0);
  const { authenticationData, Role } = useContext(AuthContext);
  const show = () => {
    if (ShowItems === false) {
      if (props.propGlobal === true) {
        props.setpropGlobal(false);
      } else {
        props.setpropGlobal(true);
      }
      setTimeout(() => {
        setShowItems(true);
      }, 50);
    } else {
      setShowItems(false);
    }
  };

  useEffect(() => {
    setShowItems(false);
  }, [props.propGlobal]);

  const setModalPoup = (obj) => {
    setOpen(true);
    setItemId(obj.target.id);
  };

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const deleteProp = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        var formdata = new FormData();

        formdata.append("id", e.target.id);
        axios
          .post(
            authenticationData.ApiBaseURL + "/api/Administration/deleteProp",
            formdata,
            {
              headers: {
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.response == "Success") {
              props.getPropFolderDataBykeyword(props.searchKeyword);
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
              Swal.fire("Deleted!", "Not deleted", "Failed");
            }
          })
          .catch((excetion) => {
            console.log(excetion);
          });
      }
    });
  };

  return (
    <div style={{ width: "100%", borderRadius: "6px" }}>
      <div style={{ width: "100%", height: "auto" }}>
        <div className="Char_assetsList">
          {props.item.length > 0 &&
            props.item.map((obj, index) => (
              <div key={index} className="Asset_items">
                {Role == "admin" && (
                  <>
                    <div className="adminIconsUpload" title="Admin Edit Prop">
                      <span
                        id={obj.id}
                        className="material-icons"
                        onClick={(e) => setModalPoup(e)}
                        style={{ fontSize: "14px", lineHeight: "12px" }}
                      >
                        edit
                      </span>
                    </div>
                    <div className="adminIconsDelete" title="Admin Prop Delete">
                      <span
                        className="material-icons"
                        onClick={deleteProp}
                        id={obj.id}
                        style={{ fontSize: "14px", lineHeight: "12px" }}
                      >
                        delete
                      </span>
                    </div>
                  </>
                )}

                <PropsLoader
                  Folder={"props-"}
                  ImgPath={obj.img}
                  name={props.name}
                  ind={index}
                  Item_Path={obj.item_Path}
                />
              </div>
            ))}
          {props.item.length == 0 && (
            <div className="Asset_items" style={{ margin: "0 auto" }}>
              <div
                className="Asset_items_start"
                style={{ textAlign: "center" }}
              >
                No Record Found
              </div>
            </div>
          )}

          {open === true && (
            <UpdateTags
              type={"Props"}
              itemId={itemId}
              open={open}
              setOpen={setOpen}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AssetPropSearch;
